import Navbar from './components2/Navbar'
import Hero from './components2/Hero'
import HowItWorks from './components2/HowItWorks'
import Tours from './components2/Tours'
import Packages from './components2/Packages'
import WhyUs from './components2/WhyUs'
import Testimonials from './components2/Testimonials'
import FAQ from './components2/FAQ'
import QuoteCTA from './components2/QuoteCTA'
import Footer from './components2/Footer'

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <HowItWorks />
        <Tours />
        <Packages />
        <WhyUs />
        <Testimonials />
        <FAQ />
        <QuoteCTA />
      </main>
      <Footer />
    </>
  )
}
